/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import React from 'react';
import { Banner, InfoInactiveIcon, Text } from '@getgo/chameleon-chakra-ui';
import { Link } from '../Link/Link';
import { useLocalStorage } from 'react-use';
import { isMobileJoinTechnicallySupported } from '../../services/ProductCompatibilityService';

interface Props {
  localStorageId: string;
  text: string;
  url: string;
  linkText: string;
}

export const InfoBanner = (props: Props) => {
  const [showBanner, setShowBanner] = useLocalStorage(
    props.localStorageId,
    !isMobileJoinTechnicallySupported
  );
  const closeBanner = () => {
    setShowBanner(false);
  };
  if (showBanner) {
    return (
      <Banner onClose={closeBanner} fontWeight='bold' alignItems='center'>
        <InfoInactiveIcon mr={3} boxSize={5} />
        <Text fontSize='lg'>
          {props.text}
          <Link
            textDecoration='underline'
            ml={2}
            isExternal={true}
            href={props.url}
          >
            {props.linkText}
          </Link>
        </Text>
      </Banner>
    );
  }
  return null;
};
